var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 468,
    viewBox: "0 0 468 468",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.445312,
    y: 0.552734,
    width: 467.447,
    height: 467.447,
    rx: 116.302,
    fill: "#B59748"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.336 234.275V93.7012H376.91C376.91 171.32 313.955 234.275 236.336 234.275Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7578 374.85L95.7578 234.276L236.332 234.276C236.332 311.895 173.377 374.85 95.7578 374.85Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M376.905 374.592L236.078 234.27L376.652 234.018L376.905 374.592Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M236.082 93.7012L95.5078 234.275V93.7012H236.082Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da902abd098c36d71f2a3fa024ca7184.svg";
export { ForwardRef as ReactComponent };